import { useState } from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import DowntimeByRigComparisonFilters from "./downtimeByRigComparisonFilters";
import DowntimeByRigComparisonBody from './downtimeByRigComparisonBody';
import LoadingIndicator from "../../../common/loadingIndicator";

/**
 * Downtime by rig comparison component
 * @returns {JSX.Element}
 * @constructor
 */

const DowntimeByRigComparison = () => {
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({
        date: '',
        isLoading: false,
        isSubmitted: false,
    });

    return (
        <>
            <Breadcrumb title="Average Downtime By Rig Comparison" parent="Downtime"/>
            <div className="s-downtime-report">
                <DowntimeByRigComparisonFilters {...{data, setData, setFilters}} />
                <DowntimeByRigComparisonBody {...{filters, data}} />
            </div>
            <LoadingIndicator isLoading={filters.isLoading}/>
        </>
  );
}

export default DowntimeByRigComparison;
